export * from './src/devcenter-scripts-v1-script-properties-embedded-scripts.universal.js';
